import {Disable, FEATURES} from './useVIToggle.constants';
import {useState} from 'react';
import {request} from '../../services/HttpRequestService';
import {storageService} from '../../services/storageService';

const useVIToggle = () => {
    const [featuresObj, setFeaturesObj] = useState({});

    /**
     * getViFeatures -  get vi features permissions from server
     */
    const getViFeatures = async () => {
        try {
            const res = await request.get(storageService.loadFromStorage('token'), 'VI_FEATURES', false, '');

            const viFeaturesList = res.data;
            const featuresObjTemp = {};

            viFeaturesList.forEach((feature) => {
                const viSettings = feature.feature_settings_list;

                featuresObjTemp[feature.feature_name] = {
                    status: feature.status,
                    extra: {}
                };

                viSettings.forEach((subFeature) => {
                    featuresObjTemp[subFeature.feature_settings_name] = {
                        status: subFeature.feature_settings_status,
                        extra: subFeature.feature_settings_extra
                    };
                });
            });

            setFeaturesObj(featuresObjTemp);
        } catch (e) {
            console.log(e);
        }
    };

    /**
     * showComponentCase - control the view of the component according feature case
     * @param Component - react Component
     * @param featureName - featureName (string)
     * @param props - react props
     */
    const showComponentCase = (Component, featureName, props) => {
        if (featuresObj[featureName]) {
            const {status} = featuresObj[featureName];

            switch (status) {
                case 'Disabled':
                    return [Disable[FEATURES[featureName]], true];
                case 'Not_allowed':
                    return [props, false];
                default:
                    return [props, true];
            }
        } else {
            return [props, false];
        }
    };

    return {showComponentCase, getViFeatures};
};

export default useVIToggle;
